module.exports = __webpack_public_path__ + "static/media/webroll.dacb0355.mp4";